/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Calculation function to be applied on a set of values:
 * * RAW: Return the raw value
 * * MIN: Return the minimum value in a given set of values
 * * MAX: Return the maximum value in a given set of values
 * * MEDIAN: Return the median value in a given set of values
 * * AVERAGE: Return the average of a set of values
 */
export enum CalculationFunctionType {
  RAW = 'RAW',
  MIN = 'MIN',
  MAX = 'MAX',
  MEDIAN = 'MEDIAN',
  AVERAGE = 'AVERAGE'
}
